import { localCalendarDate } from '@shared/dates/calendarDate';
export const toIsoDate = (value: Date): string => localCalendarDate(value);

/**
 * Resolve a saved-view window (relative or absolute) to concrete dates.
 */
export const resolveWindow = (
  window:
    | { kind: 'relative_days'; days: number }
    | { kind: 'absolute'; start: string; end: string }
    | undefined,
): { start: string; end: string } => {
  if (!window) {
    return defaultWindow();
  }
  if (window.kind === 'absolute') {
    return { start: window.start, end: window.end };
  }
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - Math.max(window.days - 1, 0));
  return { start: toIsoDate(start), end: toIsoDate(end) };
};

export const defaultWindow = (): { start: string; end: string } => {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - 13); // last 14 days inclusive
  return { start: toIsoDate(start), end: toIsoDate(end) };
};

/**
 * The window a report opens on: N days ending today, or — for
 * forward-looking reports like the schedule — N days starting today.
 */
export const windowForDefinition = (
  days: number,
  forward: boolean,
): { start: string; end: string } => {
  const today = new Date();
  const other = new Date();
  const span = Math.max(days - 1, 0);
  other.setDate(forward ? today.getDate() + span : today.getDate() - span);
  return forward
    ? { start: toIsoDate(today), end: toIsoDate(other) }
    : { start: toIsoDate(other), end: toIsoDate(today) };
};
